import React from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { MEDIA } from "../../data/content";

export default function Media() {
  return (
    <section id="media" data-testid="media-section" className="section-pad relative z-10 bg-[#0c0c0b]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="overline mb-4">Press & Media</div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight mb-14">
            In The <span className="text-amber">News.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-5">
          {MEDIA.map((m, i) => (
            <Reveal key={m.outlet} delay={(i % 2) * 0.1} as="div">
              <a
                href="#"
                data-testid={`media-${i}`}
                className="group flex gap-5 rounded-xl border border-white/[0.07] bg-surface p-6 hover:border-amber/30 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="shrink-0 h-16 w-16 rounded-lg bg-obsidian border border-white/10 flex items-center justify-center text-center font-display text-[0.7rem] font-bold leading-tight text-amber whitespace-pre-line">
                  {m.badge}
                </div>
                <div className="flex-1">
                  <div className="text-[0.72rem] uppercase tracking-[0.14em] text-ink-muted">{m.outlet}</div>
                  <div className="font-display text-lg font-medium mt-1 leading-snug">{m.headline}</div>
                  <div className="mt-3 flex items-center gap-2 text-sm text-ink-muted">
                    <span>{m.date}</span>
                    <span className="h-1 w-1 rounded-full bg-amber" />
                    <span>{m.kind}</span>
                  </div>
                </div>
                <ArrowUpRight
                  size={18}
                  className="shrink-0 text-ink-muted group-hover:text-amber transition-colors duration-300"
                />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
